import { useEffect, useRef } from 'react';
import { useViewer } from '../../../contexts/ViewerContext';
import { ViewCube } from 'viewer3d';
import './ViewCubeComponent.scss';


export function ViewCubeComponent() {
  const { viewer } = useViewer();
  const divRef = useRef<HTMLDivElement| null>(null);
  const viewCubeRef = useRef<ViewCube | null>(null);

  useEffect(() => {
    const currentDivRef = divRef.current;

    if (viewer && currentDivRef) {
      const viewCube = new ViewCube(viewer);
      currentDivRef.appendChild(viewCube.getRootElement());
      viewCubeRef.current = viewCube;
    }

    return () => {
      if (currentDivRef) {
        currentDivRef.innerHTML = '';
      }

      if (viewCubeRef.current) {
        viewCubeRef.current.dispose();
      }
    }
  }, [viewer]);


  return (
    <div ref={divRef}></div>
  );
}
